import { render, staticRenderFns } from "./MonthlyStatistics.vue?vue&type=template&id=b18fc980&scoped=true&"
import script from "./MonthlyStatistics.vue?vue&type=script&lang=js&"
export * from "./MonthlyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyStatistics.vue?vue&type=style&index=0&id=b18fc980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18fc980",
  null
  
)

export default component.exports